import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import React, { memo, useState } from "react";
import {
  View,
  StyleSheet,
  TextInput,
  TouchableOpacity,
  TouchableWithoutFeedback,
  Modal,
  ScrollView,
  ActivityIndicator,
} from "react-native";
import Route from "@assets/svg/DeliveryRoutes/route";
import color from "@constants/color";
import Text from "@components/CustomText";
import Cross from "@assets/svg/CrossIcon";
import AddDeliveryBoy from "@screens/CpDeliveryBoys/AddDeliveryBoy";
import MiniScooter from "@assets/svg/CpDeliveryBoys/mini_scooter";
import {
  addDBRoute,
  deleteDBRoute,
  getAllCpDbs,
  updateDBRoute,
} from "@services/api";
import Button from "@components/Button";
import t from "@constants/localization";
import { useSelector } from "react-redux";

const AddDeliveryRoute = ({ navigation, route }) => {
  const { isEdit, routeData } = route?.params || {};
  const [routeName, setRouteName] = useState(
    isEdit ? routeData.route_name : "",
  );
  const [cpDeliveryBoys, setCpDeliveryBoys] = useState([]);
  const [inputFocus, setInputFocus] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedDb, setSelectedDb] = useState({});

  const [showDeleteRouteModal, setShowDeleteRouteModal] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [deleteModalText, setDeleteModalText] = useState("");
  const [errorText, setErrorText] = useState("");
  React.useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { disable_add_db_btn = false } = useSelector(
    ({ configReducer }) => configReducer,
  );

  const PATH = "screens/CpDeliveryRoutes/DeliveryRoute";

  const fetchData = async (addedDB) => {
    try {
      setIsLoading(true);
      const { data } = await getAllCpDbs();
      setCpDeliveryBoys(data?.dbs || []);
      data?.dbs?.length > 0 &&
        data?.dbs?.map((db) =>
          db.id === routeData?.db_id
            ? setSelectedDb(db)
            : addedDB
              ? setSelectedDb(addedDB)
              : null,
        );
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const onPressDbPill = (db) => {
    if (selectedDb?.id === db.id) {
      setSelectedDb({});
    } else {
      setSelectedDb(db);
    }
  };
  const addRoute = async () => {
    try {
      if (routeName.length === 0) {
        setErrorText(t(`${PATH}/routeNameError`));
        return;
      }
      const { data } = await addDBRoute({
        route_name: routeName.trim(),
        db_id: selectedDb?.id,
      });
      if (data) {
        navigation.goBack();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateRoute = async () => {
    try {
      if (routeName.length === 0) {
        setErrorText(t(`${PATH}/routeNameError`));
        return;
      }
      const { data } = await updateDBRoute({
        route_name: routeName.trim(),
        db_id: selectedDb?.id || "UNASSIGN",
        route_id: routeData?.route_id,
      });
      if (data) {
        navigation.goBack();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const deleteRoute = async (override) => {
    try {
      const { data } = await deleteDBRoute({
        route_id: routeData?.route_id,
        override: override || false,
      });
      if (data?.statusCode === 200) {
        setShowDeleteRouteModal(false);
        navigation.goBack();
      } else if (data?.warningMessage) {
        setShowDeleteRouteModal(true);
        setDeleteModalText(data?.warningMessage);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <View style={{ flex: 1 }}>
      <HeaderWithBackAndTitle
        headertitle={t(`${PATH}/addDeliveryRoute`)}
        headerColor="#fff"
        hideShadow={false}
        navigation={navigation}
        route={route}
      />
      <ScrollView
        keyboardShouldPersistTaps="handled"
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.container}>
          <View style={styles.header}>
            <View
              style={{
                backgroundColor: "rgba(237, 28, 36, 0.1)",
                padding: 10,
                borderRadius: 50,
                right: 5,
              }}
            >
              <Route />
            </View>
            <Text variant="body_text_4" style={styles.headerText}>
              {t(`${PATH}/createRoute`)}
            </Text>
          </View>
          <View style={styles.inputContainer}>
            <TextInput
              testID="adr-name"
              placeholder={t(`${PATH}/routeNamePlaceholder`)}
              value={routeName}
              keyboardType="visible-password"
              onFocus={() => setInputFocus(true)}
              onBlur={() => setInputFocus(false)}
              onChangeText={(nameTxt) => {
                setRouteName(nameTxt);
              }}
              style={[
                styles.input,
                inputFocus
                  ? {
                      borderColor: color.primary,
                      borderWidth: 1.3,
                    }
                  : null,
              ]}
            />
            {errorText.length > 0 && (
              <Text
                variant="caption_2"
                style={{
                  color: color.plain_red,
                }}
              >
                {errorText}
              </Text>
            )}
          </View>
          {isloading ? (
            <View
              style={{
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ActivityIndicator size="large" color={color.primary} />
            </View>
          ) : cpDeliveryBoys?.length > 0 ? (
            <View style={{ paddingHorizontal: 16 }}>
              <Text
                variant="body_text_4"
                style={{ color: color.mediumBlacklightBlack, marginBottom: 5 }}
              >
                {t(`${PATH}/addDeliveryBoy`)}
              </Text>
              <DbList
                dbsList={cpDeliveryBoys}
                onPressDbPill={onPressDbPill}
                selectedDb={selectedDb}
              />
              {disable_add_db_btn ? null : (
                <TouchableOpacity
                  testID="adr-add-db"
                  onPress={() => setShowModal(true)}
                >
                  <Text
                    variant="subtitle_16"
                    style={{ color: "#FF2E00", marginTop: 20 }}
                  >
                    {t(`${PATH}/newDeliveryBoy`)}
                  </Text>
                </TouchableOpacity>
              )}
            </View>
          ) : (
            <View style={{ alignItems: "center", marginBottom: 10 }}>
              <View style={{ marginBottom: 10, marginRight: 10 }}>
                <MiniScooter width={62} height={62} />
              </View>
              <Text
                variant="body_text_4"
                style={{ color: color.mediumBlacklightBlack }}
              >
                {t(`${PATH}/emptytext`)}
              </Text>
              <TouchableOpacity
                testID="adr-add-db"
                onPress={() => setShowModal(true)}
              >
                <Text
                  variant="subtitle_16"
                  style={{ color: "#FF2E00", marginTop: 10 }}
                >
                  {t(`${PATH}/newDeliveryBoy`)}
                </Text>
              </TouchableOpacity>
            </View>
          )}
          <View style={{ padding: 16 }}>
            {!isEdit ? (
              <Button
                btnText={t(`${PATH}/addDeliveryRoute`)}
                onPress={addRoute}
                buttonWidth="100%"
                buttonColor={color.plain_green}
                borderRadius={8}
                height={45}
                fontSize={14}
              />
            ) : (
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  btnText={t(`${PATH}/remove`)}
                  onPress={() => deleteRoute(false)}
                  buttonWidth="98%"
                  buttonColor={color.white}
                  textColor="#FF2E00"
                  borderColor="#FF2E00"
                  borderRadius={8}
                  height={45}
                  fontSize={14}
                />
                <Button
                  btnText={t(`${PATH}/update`)}
                  onPress={updateRoute}
                  buttonWidth="98%"
                  buttonColor={color.plain_green}
                  borderColor={color.plain_green}
                  borderRadius={8}
                  height={45}
                  fontSize={14}
                />
              </View>
            )}
          </View>
        </View>
      </ScrollView>
      <AddDbModal
        showModal={showModal}
        setShowModal={setShowModal}
        fetchData={fetchData}
      />
      <DeleteRouteModal
        showDeleteRouteModal={showDeleteRouteModal}
        setShowDeleteRouteModal={setShowDeleteRouteModal}
        onPressDeleteRoute={() => {
          deleteRoute(true);
        }}
        modalText={deleteModalText}
        path={PATH}
      />
    </View>
  );
};

const AddDbModal = ({ showModal, setShowModal, fetchData }) => (
  <Modal visible={showModal} animationType="fade" transparent>
    <TouchableWithoutFeedback
      onPress={() => {
        setShowModal(false);
      }}
    >
      <View style={styles.modalOverlay} />
    </TouchableWithoutFeedback>
    <View style={styles.modalContent}>
      <View style={styles.modalCross}>
        <TouchableWithoutFeedback onPress={() => setShowModal(false)}>
          <Cross width={16} height={16} />
        </TouchableWithoutFeedback>
      </View>
      <AddDeliveryBoy setShowAddDbModal={setShowModal} fetchData={fetchData} />
    </View>
  </Modal>
);

const DbList = memo(({ dbsList, onPressDbPill, selectedDb }) => (
  <View style={styles.dbListContainer}>
    {dbsList?.map((db, index) => {
      const isSelected = db?.id === selectedDb?.id;
      return (
        <TouchableWithoutFeedback onPress={() => onPressDbPill(db)}>
          <View
            style={[
              styles.pill,
              {
                backgroundColor: isSelected ? color.black : color.white,
                borderWidth: isSelected ? 0 : 1,
                overflow: "hidden",
              },
            ]}
          >
            <Text
              variant="body_text_3"
              numberOfLines={1}
              style={isSelected ? styles.selectedText : styles.nonSelectedText}
            >
              {db.db_name}
            </Text>
          </View>
        </TouchableWithoutFeedback>
      );
    })}
  </View>
));

const DeleteRouteModal = ({
  showDeleteRouteModal,
  setShowDeleteRouteModal,
  onPressDeleteRoute,
  modalText,
  path,
}) => (
  <Modal
    animationType="fade"
    transparent={true}
    visible={showDeleteRouteModal}
    onRequestClose={() => {
      setShowDeleteRouteModal(!showDeleteRouteModal);
    }}
  >
    <TouchableWithoutFeedback onPress={() => setShowDeleteRouteModal(false)}>
      <View style={styles.modalOverlay} />
    </TouchableWithoutFeedback>
    <View style={styles.deleteModalContainer}>
      <Text variant="body_text_1">{modalText}</Text>
      <View style={styles.deleteModalRow}>
        <TouchableWithoutFeedback
          onPress={() => setShowDeleteRouteModal(false)}
        >
          <Text
            variant="body_text_4"
            style={{ padding: 10, color: color.darkGrey }}
          >
            {t(`${path}/modalNo`)}
          </Text>
        </TouchableWithoutFeedback>
        <TouchableWithoutFeedback onPress={onPressDeleteRoute}>
          <Text
            variant="body_text_4"
            style={{ padding: 10, color: color.primary }}
          >
            {t(`${path}/modalYes`)}
          </Text>
        </TouchableWithoutFeedback>
      </View>
    </View>
  </Modal>
);

export default AddDeliveryRoute;

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    margin: 16,
    borderRadius: 10,
    borderColor: color.extraLightBlack,
    borderWidth: 0.5,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    padding: 16,
    paddingBottom: 0,
    justifyContent: "flex-start",
  },
  headerText: {
    marginLeft: 4,
  },
  inputContainer: {
    paddingHorizontal: 16,
    padding: 10,
  },
  input: {
    borderWidth: 1,
    borderColor: color.extraLightBlack,
    padding: 9,
    marginBottom: 5,
    borderRadius: 4,
  },
  modalOverlay: {
    backgroundColor: "rgba(0,0,0, 0.4)",
    flex: 1,
  },
  modalContent: {
    backgroundColor: "#fff",
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    width: "100%",
    position: "absolute",
    bottom: 0,
  },
  modalCross: {
    position: "absolute",
    right: 10,
    top: -35,
    backgroundColor: "#fff",
    borderRadius: 50,
    zIndex: 1,
    padding: 6,
  },
  dbListContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  pill: {
    flexWrap: "wrap",
    marginTop: 6,
    marginRight: 8,
    padding: 4,
    paddingHorizontal: 18,
    borderRadius: 24,
    borderColor: "rgba(0,0,0,0.2)",
  },
  selectedText: {
    color: "white",
    fontWeight: "700",
  },
  nonSelectedText: {
    color: color.mediumBlack,
  },
  deleteModalContainer: {
    width: "90%",
    margin: 20,
    backgroundColor: "white",
    borderRadius: 8,
    padding: 12,
    paddingHorizontal: 20,
    alignItems: "center",
    alignContent: "center",
    position: "absolute",
    top: "35%",
  },
  deleteModalRow: {
    width: "100%",
    flexDirection: "row",
    marginTop: 10,
    justifyContent: "flex-end",
  },
});
